import Chip from "../Chip";
import MUIGreyColor from "@mui/material/colors/grey";
import MUIAvatar from "@mui/material/Avatar";
import OrderStatusReason from "../../Utility/Crud/OrderStatusReason";
import * as MUIColors from "@mui/material/colors";
import MainContext from "../../Context/MainContext/MainContext";
import OrderStatusReasonDetail from "../../Utility/Crud/OrderStatusReasonDetail";

export default class ChipOrderStatusReason extends Chip {
  static contextType = MainContext; // For legacy class components

  /**
   * Renders a MUI Avatar.
   */
  renderAvatar() {
    let color;
    if (this.props.orderStatusReason) {
      const orderStatus =
        this.context.orderStatusesIndexed[
          this.props.orderStatusReason.orderStatus
        ];
      const colorObject = this.context.colorsIndexed[orderStatus.colorId];
      color = MUIColors[colorObject.hue][colorObject.shade];
    } else {
      color = MUIGreyColor[500];
    }

    const avatarColor = this.props.isTransparent ? "transparent" : color;
    const iconColor = this.props.isTransparent ? color : "#fff";

    return (
      <MUIAvatar sx={{ bgcolor: avatarColor }}>
        {OrderStatusReason.getIcon({
          fontSize: "small",
          sx: { color: iconColor },
        })}
      </MUIAvatar>
    );
  }

  /**
   * @return {string} The orderStatusReason description.
   */
  getLabel() {
    let label = this.props.orderStatusReason
      ? OrderStatusReason.getDisplayName(this.props.orderStatusReason)
      : "None";
    if (this.props.orderStatusReasonDetail) {
      const detailDisplayName = OrderStatusReasonDetail.getDisplayName(
        this.props.orderStatusReasonDetail,
      );
      label += ` • ${detailDisplayName}`;
    }
    return label;
  }
}
